import { CardMedia } from '@mui/material';
import procedureForOrder from 'assets/images/ProcedureForOrder.png';

export const Procedures = () => {
  return (
    <>
      <CardMedia
        component="img"
        height={700}
        sx={{ padding: '1em 1em 0 1em', objectFit: 'contain' }}
        image={procedureForOrder}
        alt="Estructura de la Alianza"
      />
    </>
  );
};
